import { styled } from "@mui/material";
import { Box } from "@mui/system";

export const CloudListItemGroup = styled(Box)(() => ({
  display: "flex",
  padding: "8px 0px",
  flexDirection: "column",
}));
